import { ErrorMessage, Field } from 'formik';
import { useState } from 'react';
import { IoMdEye, IoMdEyeOff } from "react-icons/io";
import { MdLocationOn } from 'react-icons/md';
import './Input.css';

const Input = ({ type, value, placeholder, isDisable, className, label,
    isTextArea, rows, name, error, onChange, addPlus, onPlusClick, min, max, inputRef }) => {
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = (e) => {
        e.preventDefault();
        setShowPassword(!showPassword);
    };

    const renderPasswordIcon = () => (
        <button
            type="button"
            className="password-toggle-btn"
            onClick={togglePasswordVisibility}
        >
            {showPassword ? <IoMdEyeOff /> : <IoMdEye />}
        </button>
    );

    if (onChange) {
        return (
            <div className='w-100 d-flex flex-column'>
                <label className='form-label'>
                    {label}
                    {addPlus && (
                        <span
                            onClick={(e) => {
                                e.stopPropagation();
                                onPlusClick?.();
                            }}
                            style={{ marginLeft: '5px', cursor: 'pointer' }}
                        >
                            +
                        </span>
                    )}
                </label>
                {isTextArea ? (
                    <textarea
                        name={name}
                        onChange={onChange}
                        value={value}
                        placeholder={placeholder}
                        disabled={isDisable ? isDisable : false}
                        rows={rows}
                        className={className ? className : "form-control"}
                        maxLength={max}
                    />
                ) : (
                    <div className="input-wrapper">
                        <input
                            type={type === 'password' ? (showPassword ? 'text' : 'password') : type}
                            name={name}
                            onChange={onChange}
                            value={value}
                            ref={inputRef}
                            placeholder={placeholder}
                            disabled={isDisable ? isDisable : false}
                            className={className ? className : "form-control"}
                            min={min}
                            max={max}
                            maxLength={max}
                        />
                        {type === 'password' && renderPasswordIcon()}
                        {inputRef && <MdLocationOn className='location_icon' />}
                    </div>
                )}
                {error && <div className="error-message">{error}</div>}
            </div>
        )
    }

    return (
        <div className='w-100 d-flex flex-column'>
            <label className='form-label'>
                {label}
                {addPlus && (
                    <span
                        onClick={(e) => {
                            e.stopPropagation();
                            onPlusClick?.();
                        }}
                        style={{ marginLeft: '5px', cursor: 'pointer' }}
                    >
                        +
                    </span>
                )}
            </label>
            {isTextArea ? (
                <Field
                    as="textarea"
                    name={name}
                    placeholder={placeholder}
                    disabled={isDisable ? isDisable : false}
                    rows={rows}
                    className={className ? className : "form-control"}
                    maxLength={max}
                />
            ) : (
                <div className="input-wrapper">
                    <Field
                        type={type === 'password' ? (showPassword ? 'text' : 'password') : type}
                        name={name}
                        value={value}
                        ref={inputRef}
                        placeholder={placeholder}
                        disabled={isDisable ? isDisable : false}
                        className={className ? className : "form-control"}
                        min={min}
                        max={max}
                        maxLength={max}
                    />
                    {type === 'password' && renderPasswordIcon()}
                    {inputRef && <MdLocationOn className='location_icon' />}
                </div>
            )}
            <ErrorMessage name={name} component="div" className="error-message" />
        </div>
    )
}

export default Input;